import { render, staticRenderFns } from "./PaymentCommentUpdateModal.vue?vue&type=template&id=73793234"
import script from "./PaymentCommentUpdateModal.vue?vue&type=script&lang=js"
export * from "./PaymentCommentUpdateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports